import { format, parseISO } from 'date-fns'
import { FC, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { getProductByCustomerData } from '../../api/contracts'
import { Layout } from '../../components/Layout'
import { Product } from '../../models/contractsModel'

export const WarrantyTerms: FC = () => {
  const [product, setProduct] = useState<Product>()
  const query = new URLSearchParams(useLocation().search)
  const contractId = query.get('contractId')
  const customerId = query.get('customerId')

  useEffect(() => {
    const init = async () => {
      if (!contractId || !customerId) return

      const productRes = await getProductByCustomerData({
        contractId,
        customerId,
      })
      setProduct(productRes)
    }
    init()
  }, [])

  if (!product)
    return (
      <p
        css={css`
          text-align: center;
          margin-top: 60px;
        `}
      >
        不正なアクセスです
      </p>
    )

  const {
    storeName,
    storeWebSite,
    productTitle,
    productImageUrl,
    planTitle,
    isFulfilled,
    transactionDate,
    startedAt,
    endedAt,
  } = product

  const formatToJapaniseYmd = (dateISOString: string) => format(parseISO(dateISOString), 'yyyy年MM月dd日')

  return (
    <Layout>
      <StyledWrap>
        <StyledH1>保証内容の詳細</StyledH1>
        <dl>
          <StyledItem>
            <dt>店舗名</dt>
            <dd>{storeName}</dd>
          </StyledItem>
          <StyledItem>
            <dt>保証内容</dt>
            <dd>{storeWebSite}</dd>
          </StyledItem>
          <StyledItem>
            <dt>商品</dt>
            <dd>
              <img
                src={productImageUrl}
                alt={productTitle}
                css={css`
                  width: 66px;
                  padding-right: 10px;
                `}
              />
              {productTitle}
            </dd>
          </StyledItem>
          <StyledItem>
            <dt>プラン名</dt>
            <dd>{planTitle}</dd>
          </StyledItem>
          <StyledItem>
            <dt>購入時期</dt>
            <dd>{formatToJapaniseYmd(transactionDate)}</dd>
          </StyledItem>
          <StyledItem>
            <dt>保証期間</dt>
            <dd>
              {formatToJapaniseYmd(startedAt)}〜{formatToJapaniseYmd(endedAt)}
            </dd>
          </StyledItem>
          <StyledItem>
            <dt>保証履行</dt>
            <dd>{isFulfilled ? '済み' : '未履行'}</dd>
          </StyledItem>
        </dl>
      </StyledWrap>
    </Layout>
  )
}
const StyledWrap = styled.div`
  padding: 10vw 3vw;
  @media screen and (min-width: 767px) {
    padding: 60px 100px;
  }
`
const StyledH1 = styled.h1`
  font-size: 1.7rem;
  margin: 0 0 60px;
  text-align: center;
`
const StyledItem = styled.div`
  display: flex;
  margin-bottom: 18px;
  align-items: flex-start;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 18px;
  dt {
    flex: 0 1 30%;
    font-weight: bold;
    font-size: 1.1rem;
    @media screen and (min-width: 767px) {
      flex: 0 1 18%;
    }
  }
`
